//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface ICommercialVehicleClient {
	/**
	 * Creates a commercial vehicle quote based on the provided command.
	 * @param body (optional) The creation request.
	 * @return OK
	 */
	createQuote(
		body: CreateCommercialVehicleQuoteCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<CvRestartResponse>;
	/**
	 * Updates a commercial vehicle quote based on the provided command.
	 * @param body (optional) The update request.
	 * @return OK
	 */
	updateQuote(
		body: UpdateCommercialVehicleQuoteCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<CvRestartResponse>;
	/**
	 * Sets or unsets NCD Protection on a Quote.
	 * @param body (optional) The update request.
	 * @return OK
	 */
	setNCDProtection(
		body: SetNCDProtectionCommercialVehicleQuoteCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<CvRestartResponse>;
	/**
	 * Take up Commercial Vehicle Quote
	 * @param body (optional) Commercial vehicle take up and payment details
	 * @return Payment and policy take up successful
	 */
	takeUpQuote(body: CvTakeUpQuoteCommand | undefined, cancelToken?: CancelToken): Promise<TakeUpDetailsResponse>;
}

export class CommercialVehicleClient implements ICommercialVehicleClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? '';
	}

	/**
	 * Creates a commercial vehicle quote based on the provided command.
	 * @param body (optional) The creation request.
	 * @return OK
	 */
	createQuote(
		body: CreateCommercialVehicleQuoteCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<CvRestartResponse> {
		let url_ = this.baseUrl + '/api/v1/CommercialVehicle/CreateQuote';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processCreateQuote(_response);
			});
	}

	protected processCreateQuote(response: AxiosResponse): Promise<CvRestartResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<CvRestartResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else if (status === 500) {
			const _responseText = response.data;
			return throwException('Internal Server Error', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<CvRestartResponse>(null as any);
	}

	/**
	 * Updates a commercial vehicle quote based on the provided command.
	 * @param body (optional) The update request.
	 * @return OK
	 */
	updateQuote(
		body: UpdateCommercialVehicleQuoteCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<CvRestartResponse> {
		let url_ = this.baseUrl + '/api/v1/CommercialVehicle/UpdateQuote';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processUpdateQuote(_response);
			});
	}

	protected processUpdateQuote(response: AxiosResponse): Promise<CvRestartResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<CvRestartResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Not Found', status, _responseText, _headers, result404);
		} else if (status === 500) {
			const _responseText = response.data;
			return throwException('Internal Server Error', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<CvRestartResponse>(null as any);
	}

	/**
	 * Sets or unsets NCD Protection on a Quote.
	 * @param body (optional) The update request.
	 * @return OK
	 */
	setNCDProtection(
		body: SetNCDProtectionCommercialVehicleQuoteCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<CvRestartResponse> {
		let url_ = this.baseUrl + '/api/v1/CommercialVehicle/SetNCDProtection';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processSetNCDProtection(_response);
			});
	}

	protected processSetNCDProtection(response: AxiosResponse): Promise<CvRestartResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<CvRestartResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Not Found', status, _responseText, _headers, result404);
		} else if (status === 500) {
			const _responseText = response.data;
			return throwException('Internal Server Error', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<CvRestartResponse>(null as any);
	}

	/**
	 * Take up Commercial Vehicle Quote
	 * @param body (optional) Commercial vehicle take up and payment details
	 * @return Payment and policy take up successful
	 */
	takeUpQuote(body: CvTakeUpQuoteCommand | undefined, cancelToken?: CancelToken): Promise<TakeUpDetailsResponse> {
		let url_ = this.baseUrl + '/api/v1/CommercialVehicle/TakeUpQuote';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processTakeUpQuote(_response);
			});
	}

	protected processTakeUpQuote(response: AxiosResponse): Promise<TakeUpDetailsResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<TakeUpDetailsResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status === 402) {
			const _responseText = response.data;
			let result402: any = null;
			let resultData402 = _responseText;
			result402 = resultData402;
			return throwException('Payment Required', status, _responseText, _headers, result402);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<TakeUpDetailsResponse>(null as any);
	}
}

export interface IPaymentClient {
	/**
	 * Create a Braintree payment intent
	 * @param body (optional) Take up and payment details
	 * @return Payment and policy take up successful
	 */
	makePaymentIntent(
		body: MakePaymentIntentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<PaymentIntentResponse>;
	/**
	 * Get Client Data
	 * @return Client Data Response
	 */
	getClientData(cancelToken?: CancelToken): Promise<GetClientDataResponse>;
}

export class PaymentClient implements IPaymentClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? '';
	}

	/**
	 * Create a Braintree payment intent
	 * @param body (optional) Take up and payment details
	 * @return Payment and policy take up successful
	 */
	makePaymentIntent(
		body: MakePaymentIntentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<PaymentIntentResponse> {
		let url_ = this.baseUrl + '/api/v1/Payment/MakePaymentIntent';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processMakePaymentIntent(_response);
			});
	}

	protected processMakePaymentIntent(response: AxiosResponse): Promise<PaymentIntentResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PaymentIntentResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status === 403) {
			const _responseText = response.data;
			let result403: any = null;
			let resultData403 = _responseText;
			result403 = resultData403;
			return throwException('Quote Token provided is not valid', status, _responseText, _headers, result403);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PaymentIntentResponse>(null as any);
	}

	/**
	 * Get Client Data
	 * @return Client Data Response
	 */
	getClientData(cancelToken?: CancelToken): Promise<GetClientDataResponse> {
		let url_ = this.baseUrl + '/api/v1/Payment/GetClientData';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetClientData(_response);
			});
	}

	protected processGetClientData(response: AxiosResponse): Promise<GetClientDataResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<GetClientDataResponse>(result200);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<GetClientDataResponse>(null as any);
	}
}

export interface IPrivateCarClient {
	/**
	 * Creates a private car quote based on the provided command.
	 * @param body (optional) The creation request.
	 * @return OK
	 */
	createQuote(body: CreatePrivateCarQuoteCommand | undefined, cancelToken?: CancelToken): Promise<PcRestartResponse>;
	/**
	 * Updates a private car quote based on the provided command.
	 * @param body (optional) The update request.
	 * @return OK
	 */
	updateQuote(body: UpdatePrivateCarQuoteCommand | undefined, cancelToken?: CancelToken): Promise<PcRestartResponse>;
	/**
	 * Sets or unsets NCD Protection on a Quote.
	 * @param body (optional) The update request.
	 * @return OK
	 */
	setNCDProtection(
		body: SetNCDProtectionPrivateCarQuoteCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<PcRestartResponse>;
	/**
	 * Take up Private Car Quote
	 * @param body (optional) Private car take up and payment details
	 * @return Payment and policy take up successful
	 */
	takeUpQuote(body: PcTakeUpQuoteCommand | undefined, cancelToken?: CancelToken): Promise<TakeUpDetailsResponse>;
}

export class PrivateCarClient implements IPrivateCarClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? '';
	}

	/**
	 * Creates a private car quote based on the provided command.
	 * @param body (optional) The creation request.
	 * @return OK
	 */
	createQuote(body: CreatePrivateCarQuoteCommand | undefined, cancelToken?: CancelToken): Promise<PcRestartResponse> {
		let url_ = this.baseUrl + '/api/v1/PrivateCar/CreateQuote';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processCreateQuote(_response);
			});
	}

	protected processCreateQuote(response: AxiosResponse): Promise<PcRestartResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PcRestartResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else if (status === 500) {
			const _responseText = response.data;
			return throwException('Internal Server Error', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PcRestartResponse>(null as any);
	}

	/**
	 * Updates a private car quote based on the provided command.
	 * @param body (optional) The update request.
	 * @return OK
	 */
	updateQuote(body: UpdatePrivateCarQuoteCommand | undefined, cancelToken?: CancelToken): Promise<PcRestartResponse> {
		let url_ = this.baseUrl + '/api/v1/PrivateCar/UpdateQuote';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processUpdateQuote(_response);
			});
	}

	protected processUpdateQuote(response: AxiosResponse): Promise<PcRestartResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PcRestartResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Not Found', status, _responseText, _headers, result404);
		} else if (status === 500) {
			const _responseText = response.data;
			return throwException('Internal Server Error', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PcRestartResponse>(null as any);
	}

	/**
	 * Sets or unsets NCD Protection on a Quote.
	 * @param body (optional) The update request.
	 * @return OK
	 */
	setNCDProtection(
		body: SetNCDProtectionPrivateCarQuoteCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<PcRestartResponse> {
		let url_ = this.baseUrl + '/api/v1/PrivateCar/SetNCDProtection';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processSetNCDProtection(_response);
			});
	}

	protected processSetNCDProtection(response: AxiosResponse): Promise<PcRestartResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PcRestartResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Not Found', status, _responseText, _headers, result404);
		} else if (status === 500) {
			const _responseText = response.data;
			return throwException('Internal Server Error', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PcRestartResponse>(null as any);
	}

	/**
	 * Take up Private Car Quote
	 * @param body (optional) Private car take up and payment details
	 * @return Payment and policy take up successful
	 */
	takeUpQuote(body: PcTakeUpQuoteCommand | undefined, cancelToken?: CancelToken): Promise<TakeUpDetailsResponse> {
		let url_ = this.baseUrl + '/api/v1/PrivateCar/TakeUpQuote';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processTakeUpQuote(_response);
			});
	}

	protected processTakeUpQuote(response: AxiosResponse): Promise<TakeUpDetailsResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<TakeUpDetailsResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status === 402) {
			const _responseText = response.data;
			let result402: any = null;
			let resultData402 = _responseText;
			result402 = resultData402;
			return throwException('Payment Required', status, _responseText, _headers, result402);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<TakeUpDetailsResponse>(null as any);
	}
}

export interface Address {
	postcode: string;
	line1: string;
	line2?: string | undefined;
	line3?: string | undefined;
	line4?: string | undefined;
	city: string;
	county?: string | undefined;
	country?: string | undefined;
}

export interface CreateCommercialVehicleQuoteCommand {
	/** Gets or sets the encrypted policy token that identifies the policy to be restarted.
This token is required and must be a valid encrypted policy reference. */
	policyToken: string | undefined;
	/** Gets or sets the desired start time for the restarted policy.
Defaults to the current UTC time if not specified. */
	startTime: string;
	/** Gets or sets the reference for the restart quote.
This reference is used to track the specific quote for the restart operation. */
	restartQuoteToken?: string | undefined;
}

export interface CvTakeUpQuoteCommand {
	/** Existing quote reference */
	quoteReference: string | undefined;
	/** Payment Id from the make payment intent endpoint */
	paymentId: string | undefined;
	/** Braintree Nonce */
	nonce: string | undefined;
	/** Braintree Device Data */
	deviceData: string | undefined;
	/** Idempotence Key */
	idempotenceKey: string | undefined;
	/** The scheme to take up the quote with. */
	scheme: string | undefined;
	/** The selected payment option code. */
	paymentCollectionOptionCode: string | undefined;
	/** Post Documents */
	sendWelcomePack?: boolean;
	customerBillingDetails: CustomerBillingDetails;
	/** Set up automatic renewal for the policy after takeup. */
	automaticRenewal?: boolean;
}

/** Command to set or unset NCD (No Claims Discount) protection on a commercial vehicle quote. */
export interface SetNCDProtectionCommercialVehicleQuoteCommand {
	/** Gets or sets whether NCD protection should be enabled or disabled. */
	ncdProtection: boolean;
	/** Gets or sets the quote reference that identifies the specific quote to update.
Must match the standard Acorn format (e.g., QU123456.1). */
	quoteReference: string | undefined;
	/** Gets or sets the encrypted quote token for security validation. */
	quoteToken: string | undefined;
}

export interface UpdateCommercialVehicleQuoteCommand {
	/** Gets or sets the quote reference to be updated.
This reference is required and must be a valid quote reference. */
	quoteReference: string | undefined;
	quoteToken: string | undefined;
	quoteDetails: QuoteDetails_1OfOfCvRiskDataAndCommercialVehicleAnd_0AndCulture_neutralAndPublicKeyToken_null;
}

export interface Company {
	name: string;
	dateEstablished: string;
	staffContact: Person;
}

export interface CvCover {
	levelOfCover: string;
	effectiveFrom: string;
	voluntaryExcess?: number | undefined;
	ncdRequirements: NcdRequirements;
}

export interface CvDriver {
	licenceRestrictionsId?: string | undefined;
	driverId?: string | undefined;
	dateOfBirth: string;
	maritalStatus: string;
	mainDriver: boolean;
	relationshipToProposer: string;
	readonly isProposer?: boolean;
	driverUsage: string;
	ukResidentSinceBirth: boolean;
	dateUkResidency?: string | undefined;
	driverOccupations: DriverOccupation[];
	licenceNumber: string;
	licenceType: string;
	licencePassedDate: string;
	accessToOtherVehicles: boolean;
	hasInsuranceRefused: boolean;
	motoringClaims?: MotoringClaim[] | undefined;
	motoringConvictions?: MotoringConviction[] | undefined;
	hasNonMotoringConvictions: boolean;
	title: string;
	firstName: string;
	lastName: string;
	phoneNumber?: string | undefined;
}

export interface CvRiskData {
	coverDetails: CvCover;
	vehicleDetails: CvVehicle;
	driverDetails: CvDriver[];
	proposerDetails: Proposer;
}

export interface CvVehicle {
	maxPayload?: number;
	businessMileage?: string | undefined;
	internalRacking?: boolean;
	dangerousGoods?: boolean;
	hazardousSites?: boolean;
	businessRadius?: string | undefined;
	registration: string;
	abiCode: string;
	abiGroup: string;
	make: string;
	model: string;
	bodyType: string;
	engineSize: number;
	fuelType: string;
	transmission: string;
	yearOfManufacture: number;
	value: number;
	whereParkedOvernight: string;
	overnightAddress?: Address;
	isLeftHandDrive?: boolean;
	modifications?: VehicleModification[] | undefined;
	datePurchased?: string | undefined;
	owner: string;
	registeredKeeper: string;
	isImported: boolean;
	numberOfSeats: number;
	vehicleUse: string;
	numberOfDoors: number;
	registrationDate: string;
	countryOfRegistration?: string | undefined;
	grossWeight?: number | undefined;
}

export interface DriverOccupation {
	occupation: string;
	businessType: string;
	employmentStatus: string;
	isPartTime: boolean;
}

export enum PartyType {
	INDIVIDUAL = 'INDIVIDUAL',
	ORGANISATION = 'ORGANISATION',
}

export enum PreparePaymentSource {
	CARD = 'CARD',
	WALLET = 'WALLET',
}

export enum WelcomePackSendStatus {
	NOT_ENABLED = 'NOT_ENABLED',
	ENQUEUED = 'ENQUEUED',
	NOT_SENT = 'NOT_SENT',
	FAILED_TO_SEND = 'FAILED_TO_SEND',
}

export interface MarketingPreferences {
	smsOptIn?: boolean;
	emailOptIn?: boolean;
	phoneOptIn?: boolean;
}

export interface ProblemDetails {
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

export interface CardHolderDetails {
	firstName: string;
	lastName: string;
	email: string;
	phone?: string | undefined;
}

export interface PaymentCollectionOption {
	code: string;
	upFrontAmount: number;
	unequalInstalmentAmount?: number | undefined;
	standardInstalmentAmount: number;
	apr?: number | undefined;
	interestAmount?: number | undefined;
	totalAmountPayable: number;
	paymentMethod?: PaymentMethods;
}

export interface PaymentDetails {
	saveCard: boolean;
	currencyCode: string;
	amount: number;
	billingAddress: Address;
	clientReturnURL?: string | undefined;
	cardHolderDetails?: CardHolderDetails;
}

export interface PaymentIntentResponse {
	paymentId: string;
	idempotencyKey: string;
	clientIp: string;
}

export enum PaymentMethods {
	Card = 'Card',
	DirectDebit = 'DirectDebit',
}

export interface QuoteDetails_1OfOfCvRiskDataAndCommercialVehicleAnd_0AndCulture_neutralAndPublicKeyToken_null {
	riskData: CvRiskData;
	marketingSource?: string | undefined;
	effectiveFrom: string;
	effectiveTo?: string | undefined;
}

export interface QuoteDetails_1OfOfPcRiskDataAndPrivateCarAnd_0AndCulture_neutralAndPublicKeyToken_null {
	riskData: PcRiskData;
	marketingSource?: string | undefined;
	effectiveFrom: string;
	effectiveTo?: string | undefined;
}

export interface UnderwritingResponse {
	quoteRef: string | undefined;
	readonly hasAnyQuote?: boolean;
	readonly hasAnyReferral?: boolean;
	underwrittenOptions: UnderwrittenOption[] | undefined;
	effectiveFrom: string;
	expiryDate?: string;
}

export interface CvQuoteDetails {
	riskData: CvRiskData;
	marketingSource?: string | undefined;
	effectiveFrom: string;
	effectiveTo?: string | undefined;
}

export interface CvRestartResponse {
	quoteDetails: CvQuoteDetails;
	quoteResponse: UnderwritingResponse;
	quoteToken: string | undefined;
	excessBreakdown: Excesses;
}

export interface DriverExcess {
	compulsoryAmount: number;
	dataPointId: string | undefined;
}

export interface Excesses {
	compulsoryExcesses?: UnderwrittenExcess[] | undefined;
	voluntaryExcesses?: UnderwrittenExcess[] | undefined;
	driverExcesses?: DriverExcess[] | undefined;
	otherExcesses?: UnderwrittenExcess[] | undefined;
	totalCompulsoryExcess?: number;
	totalVoluntaryExcess?: number;
}

export interface PcQuoteDetails {
	riskData: PcRiskData;
	marketingSource?: string | undefined;
	effectiveFrom: string;
	effectiveTo?: string | undefined;
}

export interface PcRestartResponse {
	quoteDetails: PcQuoteDetails;
	quoteResponse: UnderwritingResponse;
	quoteToken: string | undefined;
	excessBreakdown: Excesses;
}

export interface Address2 {
	line1?: string | undefined;
	line2?: string | undefined;
	line3?: string | undefined;
	line4?: string | undefined;
	city?: string | undefined;
	postcode?: string | undefined;
	country?: string | undefined;
	county?: string | undefined;
}

export interface CustomerBillingDetails {
	firstName: string | undefined;
	lastName: string | undefined;
	address: Address2;
}

export interface GetClientDataResponse {
	clientIp: string | undefined;
}

export interface TakeUpDetailsResponse {
	policyNumber: string;
	sendWelcomePackStatus: WelcomePackSendStatus;
}

export interface NoClaimsDiscountProtection {
	isAvailable: boolean;
	priceIncludingIpt: number;
}

export enum UnderwritingStatus {
	Quoted = 'Quoted',
	Referred = 'Referred',
	Declined = 'Declined',
}

export interface UnderwrittenAddOn {
	associatedId?: string | undefined;
	code: string | undefined;
	description: string | undefined;
	annualCost: number;
	monthlyCost: number;
	selected: boolean;
}

export interface UnderwrittenCover {
	code: string | undefined;
	description: string | undefined;
}

export interface UnderwrittenEndorsement {
	name: string;
	description: string;
}

export interface UnderwrittenExcess {
	associatedIds?: string[] | undefined;
	totalAmount?: number;
	voluntaryAmount?: number;
	compulsoryAmount?: number;
	excessCode: string | undefined;
	excessWording: string | undefined;
}

export interface UnderwrittenOption {
	termStartDate: string;
	termEndDate: string;
	scheme: string | undefined;
	noClaimsDiscountProtection?: NoClaimsDiscountProtection;
	price?: UnderwrittenPrice;
	underwrittenAddOns: UnderwrittenAddOn[] | undefined;
	underwrittenExcesses: UnderwrittenExcess[] | undefined;
	paymentCollectionOptions: PaymentCollectionOption[] | undefined;
	underwrittenEndorsements: UnderwrittenEndorsement[] | undefined;
	status: UnderwritingStatus;
	underwrittenCovers: UnderwrittenCover[] | undefined;
}

export interface UnderwrittenPrice {
	iptRate: number;
	grossPremiumAmountIncTax: number;
	iptAmount: number;
	policyAdministrationFee: number;
}

export interface MotoringClaim {
	incidentDate: string;
	claimType: string;
	totalCosts: number;
	fault: boolean;
	ncdAffected: boolean;
	claimStatus: string;
}

export interface MotoringConviction {
	convictionDate?: string | undefined;
	convictionCode: string;
	disqualified: boolean;
	points?: number | undefined;
	fine?: number | undefined;
	pending?: boolean | undefined;
	offenceDate?: string | undefined;
	banStartDate?: string | undefined;
	banEndDate?: string | undefined;
}

export interface NcdRequirements {
	protectedNcd: boolean;
	ncbYears: number;
	ncdEntitlementId?: string | undefined;
}

export interface MakePaymentIntentCommand {
	/** Quote Reference */
	quoteReference: string;
	paymentDetails: PaymentDetails;
	/** The quote token stores the state of the previously quoted request */
	quoteToken: string;
	preparePaymentSource: PreparePaymentSource;
	/** Product type for the quote (PrivateCar or CommercialVehicle) */
	productType: string;
}

export interface PcCover {
	levelOfCover: string;
	effectiveFrom: string;
	voluntaryExcess?: number | undefined;
	ncdRequirements: NcdRequirements;
}

export interface PcDriver {
	driverId?: string | undefined;
	dateOfBirth: string;
	maritalStatus: string;
	mainDriver: boolean;
	relationshipToProposer: string;
	readonly isProposer?: boolean;
	driverUsage: string;
	ukResidentSinceBirth: boolean;
	dateUkResidency?: string | undefined;
	driverOccupations: DriverOccupation[];
	licenceNumber: string;
	licenceType: string;
	licencePassedDate: string;
	accessToOtherVehicles: boolean;
	hasInsuranceRefused: boolean;
	motoringClaims?: MotoringClaim[] | undefined;
	motoringConvictions?: MotoringConviction[] | undefined;
	hasNonMotoringConvictions: boolean;
	title: string;
	firstName: string;
	lastName: string;
	phoneNumber?: string | undefined;
}

export interface PcRiskData {
	coverDetails: PcCover;
	vehicleDetails: PcVehicle;
	driverDetails: PcDriver[];
	proposerDetails: Proposer;
}

export interface PcVehicle {
	annualMileage?: number;
	businessMileage?: number | undefined;
	registration: string;
	abiCode: string;
	abiGroup: string;
	make: string;
	model: string;
	bodyType: string;
	engineSize: number;
	fuelType: string;
	transmission: string;
	yearOfManufacture: number;
	value: number;
	whereParkedOvernight: string;
	overnightAddress?: Address;
	isLeftHandDrive?: boolean;
	modifications?: VehicleModification[] | undefined;
	datePurchased?: string | undefined;
	owner: string;
	registeredKeeper: string;
	isImported: boolean;
	numberOfSeats: number;
	vehicleUse: string;
	numberOfDoors: number;
	registrationDate: string;
	countryOfRegistration?: string | undefined;
	grossWeight?: number | undefined;
}

export interface Person {
	title: string;
	firstName: string;
	lastName: string;
	phoneNumber?: string | undefined;
}

export interface CreatePrivateCarQuoteCommand {
	/** Gets or sets the encrypted policy token that identifies the policy to be restarted.
This token is required and must be a valid encrypted policy reference. */
	policyToken: string | undefined;
	/** Gets or sets the desired start time for the restarted policy.
Defaults to the current UTC time if not specified. */
	startTime: string;
	/** Gets or sets the reference for the restart quote.
This reference is used to track the specific quote for the restart operation. */
	restartQuoteToken?: string | undefined;
}

export interface PcTakeUpQuoteCommand {
	/** Existing quote reference */
	quoteReference: string | undefined;
	/** Payment Id from the make payment intent endpoint */
	paymentId: string | undefined;
	/** Braintree Nonce */
	nonce: string | undefined;
	/** Braintree Device Data */
	deviceData: string | undefined;
	/** Idempotence Key */
	idempotenceKey: string | undefined;
	/** The scheme to take up the quote with. */
	scheme: string | undefined;
	/** The selected payment option code. */
	paymentCollectionOptionCode: string | undefined;
	/** Post Documents */
	sendWelcomePack?: boolean;
	customerBillingDetails: CustomerBillingDetails;
	/** Set up automatic renewal for the policy after takeup. */
	automaticRenewal?: boolean;
}

/** Command to set or unset NCD (No Claims Discount) protection on a private car quote. */
export interface SetNCDProtectionPrivateCarQuoteCommand {
	/** Gets or sets whether NCD protection should be enabled or disabled. */
	ncdProtection: boolean;
	/** Gets or sets the quote reference that identifies the specific quote to update.
Must match the standard Acorn format (e.g., QU123456.1). */
	quoteReference: string | undefined;
	/** Gets or sets the encrypted quote token for security validation. */
	quoteToken: string | undefined;
}

export interface UpdatePrivateCarQuoteCommand {
	/** Gets or sets the quote reference to be updated.
This reference is required and must be a valid quote reference. */
	quoteReference: string | undefined;
	quoteToken: string | undefined;
	quoteDetails: QuoteDetails_1OfOfPcRiskDataAndPrivateCarAnd_0AndCulture_neutralAndPublicKeyToken_null;
}

export interface Proposer {
	partyType: PartyType;
	person?: ProposerPerson;
	company?: Company;
	emailAddress: string;
	address: Address;
	marketingPreferences?: MarketingPreferences;
}

export interface ProposerPerson {
	dateOfBirth: string;
	isHomeOwner: boolean;
	title: string;
	firstName: string;
	lastName: string;
	phoneNumber?: string | undefined;
}

export interface VehicleModification {
	isForMedicalReasons: boolean;
	modificationCode: string;
	value: number;
}

export class SwaggerException extends Error {
	override message: string;
	status: number;
	response: string;
	headers: { [key: string]: any };
	result: any;

	constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
		this.headers = headers;
		this.result = result;
	}

	protected isSwaggerException = true;

	static isSwaggerException(obj: any): obj is SwaggerException {
		return obj.isSwaggerException === true;
	}
}

function throwException(
	message: string,
	status: number,
	response: string,
	headers: { [key: string]: any },
	result?: any,
): any {
	if (result !== null && result !== undefined) throw result;
	else throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
	return obj && obj.isAxiosError === true;
}
